export default [
  {
    path: '/error-404',
    name: 'error-404',
    component: () => import('@/views/pages/miscellaneous/Error404.vue'),
    meta: {
      layout: 'full',
      resource: 'PageGeral',
    },
  },
  {
    path: '/coming-soon',
    name: 'coming-soon',
    component: () => import('@/views/pages/miscellaneous/ComingSoon.vue'),
    meta: {
      layout: 'full',
      resource: 'PageGeral',
    },
  },
  {
    path: '/not-authorized',
    name: 'not-authorized',
    component: () => import('@/views/pages/miscellaneous/NotAuthorized.vue'),
    meta: {
      layout: 'full',
      resource: 'PageGeral',
    },
  },
  {
    path: '/under-maintenance',
    name: 'under-maintenance',
    component: () => import('@/views/pages/miscellaneous/UnderMaintenance.vue'),
    meta: {
      layout: 'full',
      resource: 'PageGeral',
    },
  },
  {
    path: '/error',
    name: 'error',
    component: () => import('@/views/pages/miscellaneous/Error.vue'),
    meta: {
      layout: 'full',
      resource: 'PageGeral',
    },
  },
  {
    path: '/update-version',
    name: 'update-version',
    component: () => import('@/views/pages/miscellaneous/UpdateVersion.vue'),
    meta: {
      layout: 'full',
      resource: 'PageGeral',
    },
  },
]
